import {TextField, TextFieldProps} from "@mui/material";
import {Control, Controller, FieldValues, Path, PathValue, useFormContext} from "react-hook-form";
import {useTranslation} from "react-i18next";

type FormTextFieldProps<IFormValues extends FieldValues = FieldValues> = Omit<TextFieldProps, 'name' | 'value' | 'defaultValue'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    defaultValue?: PathValue<IFormValues, Path<IFormValues>>,
    translationLabelValue?: string
}

const FormTextField = <IFormValues extends FieldValues = FieldValues>({
    name,
    control,
    defaultValue,
    translationLabelValue,
    ...props
}: FormTextFieldProps<any>) => {
    const {t} = useTranslation(['expiredManagement']);
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            defaultValue={defaultValue}
            render={({ field, fieldState, formState }) =>
                <TextField
                    {...props}
                    ref={field.ref}
                    value={!!translationLabelValue ? t(`${translationLabelValue}.${field.value}`, field.value) : field.value}
                    onChange={(e) => {
                        props.onChange?.(e);
                        field.onChange(e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onBlur?.(e);
                        field.onBlur();
                    }}
                    error={Boolean(fieldState.error) || props.error}
                    helperText={t(!!fieldState.error?.message ? fieldState.error.message : '') || props.helperText}
                    disabled={props.disabled ?? formState.isSubmitting}
                    fullWidth
                />
            }
        />
    )
};

export default FormTextField;